import type { Probe } from '../engine/types';
import { ok, na } from '../engine/runner';
import { registerProbe } from '../engine/registry';

/** Core navigator/device identity. Contributes to the deviceInfo part. */
export const generalProbe: Probe = {
  id: 'general',
  label: 'General identity',
  layer: 'general',
  tier: 'client',
  category: 'browser',
  description: 'User-Agent, platform, and core device properties',
  budgetMs: 1000,

  async run() {
    const n = navigator as Navigator & { deviceMemory?: number };
    return {
      signals: {
        userAgent: ok(n.userAgent ?? null),
        platform: ok(n.platform ?? null),
        vendor: ok(n.vendor ?? null),
        product: ok(n.product ?? null),
        appName: ok(n.appName ?? null),
        appVersion: ok(n.appVersion ?? null),
        hardwareConcurrency: ok(n.hardwareConcurrency ?? null),
        deviceMemory: ok(n.deviceMemory ?? na<number>().value, 'client'),
        maxTouchPoints: ok(n.maxTouchPoints ?? 0),
        cookieEnabled: ok(n.cookieEnabled),
        doNotTrack: ok(n.doNotTrack ?? null),
        pdfViewerEnabled: ok('pdfViewerEnabled' in n ? n.pdfViewerEnabled : null),
        onLine: ok(n.onLine),
      },
      parts: {
        deviceInfo: {
          platform: n.platform ?? null,
          hardwareConcurrency: n.hardwareConcurrency ?? null,
          deviceMemory: (n as Navigator & { deviceMemory?: number }).deviceMemory ?? null,
          maxTouchPoints: n.maxTouchPoints ?? 0,
        },
      },
    };
  },
};

registerProbe(generalProbe);
